<template>
    <div>
      <template v-if="formItem.id">
        <div v-show="formItem.conceal!=='1'">
        <a-divider dashed v-if="!isCom && formItem.inputTip"/>
        <div class=" record " :class="isPad?'pad-font':''" style="margin-top: 3px" v-show="formItem.inputTip" v-html="formItem.inputTip">
        </div>
        <a-divider dashed v-if="!isCom" class="divider"/>
        <div class="item-tip" v-if="currentQuestionNotClose.length>0">
          <a-tooltip >
            <template slot="title">
              当前有{{currentQuestionNotClose.length}}条质疑需要关闭！
            </template>
            <a-button size="small" type="link">
              <a-icon type="info-circle" style="font-size: 18px;color: green;margin-top: 3px"/>
            </a-button>
          </a-tooltip>
        </div>
        <div class="item-tip" v-else-if="currentQuestionList.length>0">
          <a-tooltip >
            <template slot="title">
              当前有{{currentQuestionList.length}}条质疑需要处理！
            </template>
            <a-button size="small" type="link">
              <a-icon type="info-circle" style="font-size: 18px;color: red;margin-top: 3px"/>
            </a-button>
          </a-tooltip>
        </div>
        <div class="btn" v-if="showTipBtn">
          <template v-if="baseData.checked!=='1'">
            <a-tooltip  v-has="'datacheck:question'">
              <template slot="title" >
                提出质疑
              </template>
              <a-button size="small" @click="createQuestionHandle">
                <a-icon type="form" />
              </a-button>
            </a-tooltip>

            <a-tooltip  v-has="'checkdata:handleQuestion'">
              <template slot="title">
                修改数据
              </template>
              <a-button size="small" @click="updateDataHandle">
                <a-icon type="edit" />
              </a-button>
            </a-tooltip>

            <a-tooltip  v-has="'checkdata:handleQuestion'">
              <template slot="title" >
                回复质疑
              </template>
              <a-button size="small" @click="replyQuestionHandle">
                <a-icon type="message" />
              </a-button>
            </a-tooltip>

            <a-tooltip  v-has="'checkdata:closeQuestion'">
              <template slot="title">
                关闭质疑
              </template>
              <a-button size="small" @click="closeQuestionHandle">
                <a-icon type="close" />
              </a-button>
            </a-tooltip>
          </template>
          <template v-else>
            <a-tooltip style="z-index: 9999;">
              <template slot="title">
                提示：当前表单已经核查完成，不可再操作。
              </template>
              <a-button size="small" type="link" style="color:#000;">
                <a-icon type="info" />
              </a-button>
            </a-tooltip>
          </template>
          <a-tooltip  >
            <template slot="title">
              操作记录
            </template>
            <a-button size="small" @click="opRecordHandle">
              <a-icon type="snippets" />
            </a-button>
          </a-tooltip>
        </div>
        <a-form-model-item v-if="!isCom" :label="(formItem.number || '') + formItem.name" :prop="formItem.id" :ref="formItem.id" class="form-model-item" :class="isPad?'pad-font':''">          
          <form-view-item-input :baseData="baseData" :readOnly="readOnly" style="width: 100%" :form.sync="form" :form-item="formItem" @valueChange="valueChange"></form-view-item-input>
          <!--<a-tooltip placement="topLeft" v-if="formItem.description" >-->
            <!--<template slot="title">-->
              <!--{{formItem.description}}-->
            <!--</template>-->
            <!--<a-icon type="info-circle" />-->
          <!--</a-tooltip>-->
        </a-form-model-item>
        <template v-else>
          <form-view-item-input :baseData="baseData" :readOnly="readOnly" style="width: 100%" :form.sync="form" :form-item="formItem" @valueChange="valueChange"></form-view-item-input>
        </template>   
        </div>     
      </template>
      <!--        隐藏依赖项-->
        <template v-if="formItem.children">
          <template v-for="(childrenItem,cii) in formItem.children">
            <form-view-item :baseData="baseData" :readOnly="readOnly" @valueChange="valueChange" :show-tip-btn="showTipBtn" :questionList="questionList" :form-item="childrenItem" :form.sync="form" v-if=" isPatientValue(childrenItem) &&  childrenItem.scale!=='1'" :key="cii"></form-view-item>
          </template>
        </template>
      <a-modal
        title="发起质疑"
        :width="1000"
        :visible="questionVisible"
        :confirmLoading="loading"
        @ok="handleCreateQuestionSubmit"
        @cancel="handleCreateQuestionCancel">
        <a-row style="margin-bottom: 20px">
          <a-col :span="4" style="text-align: right">质疑理由：</a-col>
          <a-col :span="18">
            <a-textarea :rows="2" placeholder="请输入" v-model="questionForm.description"/>
          </a-col>
        </a-row>
      </a-modal>
      <a-modal
        title="修改数据"
        :width="1000"
        :visible="dataVisible"
        :confirmLoading="loading"
        @ok="handleDataSubmit"
        @cancel="handleDataCancel">
        <a-row style="margin-bottom: 20px">
          <a-col :span="4" style="text-align: right">修改原因：</a-col>
          <a-col :span="18">
            <div style="margin-bottom: 10px">
              <a-auto-complete
                v-model="dataForm.handleInfo"
                size="large"
                style="width: 100%"
                placeholder="请输入或选择"
              >
                <template #dataSource>
                  <a-select-option value="当时无数据">当时无数据</a-select-option>
                  <a-select-option value="误操作">误操作</a-select-option>
                  <a-select-option value="填写错误">填写错误</a-select-option>
                </template>
              </a-auto-complete>
            </div>
          </a-col>
        </a-row>
        <a-row style="margin-bottom: 20px">
          <a-col :span="4" style="text-align: right">数据修改：</a-col>
          <a-col :span="18">
            <div>{{formItem.name}}</div>
            <div>
              <form-view-item-input :baseData="baseData" :enforcement="true" :readOnly="false" :form.sync="dataForm" :form-item="formItem"></form-view-item-input>
            </div>
          </a-col>
        </a-row>

      </a-modal>
      <a-modal
        title="回复质疑"
        :width="1000"
        :visible="replyQuestionVisible"
        :confirmLoading="loading"
        @ok="handleReplyQuestionSubmit"
        @cancel="handleReplyQuestionCancel">
        <a-table
          size="middle"
          rowKey="id"
          :columns="questionColumns"
          :dataSource="currentQuestionList"
          :pagination="false"
        >
          <span slot="handleStatus" slot-scope="text,row,index">
                      <a-tag :color="text=='1'?'red':'green'">{{ text=='1'?'未处理':'已处理' }}</a-tag>
          </span>
          <span slot="status" slot-scope="text,row,index">
                      <a-tag :color="text=='1'?'red':'green'">{{ text=='1'?'未关闭':'已关闭' }}</a-tag>
          </span>          
        </a-table>        
        <a-row style="margin-bottom: 20px;margin-top: 20px">
          <a-col :span="4" style="text-align: right">回复质疑：</a-col>
          <a-col :span="18">
            <a-textarea :rows="2" placeholder="请输入" v-model="replyQuestionForm.description"/>
          </a-col>
        </a-row>
      </a-modal>      
      <a-modal
        title="关闭质疑"
        :width="1000"
        :visible="closeQuestionVisible"
        :confirmLoading="loading"
        @ok="handleCloseQuestionSubmit"
        @cancel="handleCloseQuestionCancel">
        <a-table
          size="middle"
          rowKey="id"
          :columns="questionColumns"
          :dataSource="currentQuestionList"
          :pagination="false"
        >
          <span slot="handleStatus" slot-scope="text,row,index">
                      <a-tag :color="text=='1'?'red':'green'">{{ text=='1'?'未处理':'已处理' }}</a-tag>
          </span>
          <span slot="status" slot-scope="text,row,index">
                      <a-tag :color="text=='1'?'red':'green'">{{ text=='1'?'未关闭':'已关闭' }}</a-tag>
          </span>        
        </a-table>
        <a-row style="margin-bottom: 20px;margin-top: 20px">
          <a-col :span="4" style="text-align: right">关闭理由：</a-col>
          <a-col :span="18">
            <div style="margin-bottom: 10px">
              <a-radio-group buttonStyle="solid" v-model="closeQuestion.handleInfo">
                <a-radio value="已修改">已修改</a-radio>
                <a-radio value="无需修改">无需修改</a-radio>
                <a-radio value="-1">其他</a-radio>
              </a-radio-group>
            </div>
            <div v-if="closeQuestion.handleInfo==='-1'">
              <a-textarea :rows="2"  placeholder="请输入" v-model="closeQuestion.description" />
            </div>
          </a-col>
        </a-row>
      </a-modal>
      <a-modal
        title="操作记录"
        :width="1000"
        :visible="opRecordVisible"
        :confirmLoading="loading"
        @ok="handleOpRecordSubmit"
        @cancel="handleOpRecordCancel">
        <a-table
          size="middle"

          rowKey="id"
          :columns="opColumns"
          :dataSource="opList"
          :pagination="false"
        >
          <span slot="type" slot-scope="text,row,index">
                      <a-tag :color="formOpType[text].color">{{ formOpType[text].text }}</a-tag>
          </span>
        </a-table>
      </a-modal>
    </div>
</template>

<script>
  import {formOpType} from '@/constants/patient'
  import { getAction,postAction } from '@/api/manage'
  import FormViewItemInput from './FormViewItemInput'
  import {CACHE_IS_PAD,CACHE_PROJECT_ID} from '@/constants/project'  
  import Vue from 'vue'
  export default {
    name: 'FormViewItem',
    components: { FormViewItemInput  ,},
    inject: {
      parentLoadData:{
        default: () => {}
      }
    },
    props:{
      isCom:{ //是否是其他组件使用
        type:Boolean,
        default:false,
      },
      readOnly:{
        type:Boolean,
        default:false,
      },
      questionList:{
        type:Array,
        default(){
          return []
        }
      },
      formItem:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      showTipBtn:{
        type:Boolean,
        default:false
      },
      form:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      baseData:{
        type:Object,
        default:()=>{
          return {}
        }
      },
    },
    data(){
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        loading:false,
        questionVisible:false,
        questionForm:{},
        dataVisible:false,
        dataForm:{},
        replyQuestionVisible:false,
        replyQuestionForm:{},
        closeQuestionVisible:false,
        closeQuestion:{},
        opRecordVisible:false,
        opList:[],
        isPad: Vue.ls.get(CACHE_IS_PAD),
        formOpType:formOpType,        
        questionColumns:[
          {
            title: '质疑发起方',
            align: "center",
            dataIndex: 'createType',
            width: 100
          },
          {
            title: '操作者',
            align: "center",
            dataIndex: 'createName',
            width: 100
          },
          {
            title: '操作时间',
            align: "center",
            dataIndex: 'createTime',
            width: 100
          },

          {
            title: '状态',
            align: "center",
            dataIndex: 'status',
            width: 100,
            scopedSlots: { customRender: 'status' }
          },
          {
            title: '处理状态',
            align: "center",
            dataIndex: 'handleStatus',
            width: 100,
            scopedSlots: { customRender: 'handleStatus' }
          },
          {
            title: '质疑内容',
            align: "center",
            dataIndex: 'description',
            // ellipsis: true,
            width: 200,
            // scopedSlots: { customRender: 'description' }
          },
        ],
        opColumns:[
          {
            title: '操作时间',
            align: "center",
            dataIndex: 'createTime',
            width: 100
          },
          {
            title: '操作人',
            align: "center",
            dataIndex: 'opUserRealname',
            width: 100
          },
          {
            title: '操作',
            align: "center",
            dataIndex: 'type',
            width: 100,
            scopedSlots: { customRender: 'type' }
          },
          {
            title: '内容',
            align: "center",
            dataIndex: 'info',
            ellipsis: true,
            width: 150,
          },
          {
            title: '原有答案',
            align: "center",
            dataIndex: 'oldValue',
            ellipsis: true,
            width: 100,
          },
          {
            title: '修改答案',
            align: "center",
            dataIndex: 'newValue',
            ellipsis: true,
            width: 100,
          },
        ],
      }
    },
    watch:{
      formItem(){
        this.loadData();
      },
      questionList(){
        this.loadData();
      }
    },
    computed:{
      currentQuestionList(){
        return this.questionList.filter(question=>{
          return question.formItemId==this.formItem.id
        })
      },
      currentQuestionNotClose(){
        console.log("this.questionList:" + this.questionList)
        return this.questionList.filter(question=>{
          return question.formItemId==this.formItem.id && question.handleStatus==='2' && question.status==='1'
        })
      },
    },
    mounted(){
      this.loadData();
    },

    methods:{
      valueChange(formItem,value){
        console.log("valueChange:" + this.$refs[this.formItem.id])
        if(this.$refs[this.formItem.id]){
          this.$refs[this.formItem.id].onFieldBlur()
          this.$refs[this.formItem.id].onFieldChange()
          this.$emit('valueChange',formItem,value)
        }
      },
      loadData(){
        if(this.formItem.id){
          getAction('/patient/patientFormItemOp/list',{formItemId:this.formItem.id}).then(res=>{
            if(res.success){
              this.opList = res.result
            }
          })
        }
      },      
      createQuestionHandle(){
        this.questionVisible = true
      },
      handleCreateQuestionSubmit(){
        if(!this.questionForm.description){
          return this.$message.warning('请输入质疑理由')
        }
        const params = {
          patientId:this.formItem.patientId,
          formId:this.formItem.formId,
          formItemId:this.formItem.id,
          formItemName:this.formItem.name,
          description:this.questionForm.description,
        }
        this.loading = true
        postAction('/question/patientQuestion/create',params).then(res=>{
          if(res.success){
            this.loadData()
            if(this.parentLoadData){
              this.parentLoadData()
            }
            this.handleCreateQuestionCancel()
          }
        }).finally(()=>{
          this.loading  = false
        })
      },
      handleCreateQuestionCancel(){
        this.questionVisible = false
      },

      updateDataHandle(){
        const dataForm = {}
        dataForm[this.formItem.id] = this.form[this.formItem.id]
        this.dataForm = dataForm
        this.dataVisible = true
      },
      handleDataSubmit(){
        if(!this.dataForm.handleInfo){
          return this.$message.warning('请输入修改原因');
        }
        const params = {}
        params.projectId= this.projectId
        params.formItemId = this.formItem.id
        params.info = this.dataForm.handleInfo
        params.value = this.dataForm[this.formItem.id]
        if(Array.isArray(params.value)){
          params.value = params.value.join(',')
        }
        this.loading = true
        postAction('/question/patientQuestion/updateValue',params).then(res=>{
          if(res.success){
            this.loadData()
            if(this.parentLoadData){
              this.parentLoadData()
            }
            this.handleDataCancel()
          }
        }).finally(()=>{
          this.loading  = false
        })
      },
      handleDataCancel(){
        this.dataVisible = false
      },

      replyQuestionHandle(){
        if(this.currentQuestionList.length===0){
          return this.$message.warning('当前没有质疑');
        }
        this.replyQuestionVisible = true
      },
      handleReplyQuestionSubmit(){
        if(!this.replyQuestionForm.description){
          return this.$message.warning('请输入回复内容')
        }
        const params = {
          formItemId:this.formItem.id,
          info:this.replyQuestionForm.description,
          projectId: this.projectId
        }
        this.loading = true
        postAction('/question/patientQuestion/replyQuestion',params).then(res=>{
          if(res.success){
            this.loadData()
            if(this.parentLoadData){
              this.parentLoadData()
            }
            this.handleReplyQuestionCancel()
          }
        }).finally(()=>{
          this.loading  = false
        })
      },
      handleReplyQuestionCancel(){
        this.replyQuestionVisible = false
      },

      closeQuestionHandle(){
        if(this.currentQuestionList.length===0){
          return this.$message.warning('当前没有质疑');
        }
        this.closeQuestionVisible=true
      },
      handleCloseQuestionSubmit(){
        if(!this.closeQuestion.handleInfo){
          return this.$message.warning('请选择关闭理由')
        }
        const params = {
          formItemId:this.formItem.id,
          projectId: this.projectId
        }
        if(this.closeQuestion.handleInfo==='-1'){
          if(!this.closeQuestion.description){
            return this.$message.warning('请输入“其他”关闭理由')
          }else{
            params.description = this.closeQuestion.description
          }
        }else{
          params.description = this.closeQuestion.handleInfo
        }
        postAction('/question/patientQuestion/close',params).then(res=>{
          if(res.success){
            this.loadData()
            if(this.parentLoadData){
              this.parentLoadData()
            }
            this.handleCloseQuestionCancel()
          }
        })
      },
      handleCloseQuestionCancel(){
        this.closeQuestionVisible=false
      },

      opRecordHandle(){
        this.opRecordVisible = true
      },
      handleOpRecordSubmit(){},
      handleOpRecordCancel(){
        this.opRecordVisible = false
      },

      isPatientValue(childrenItem){        
        if(this.form[this.formItem.id] ==null ){
          return false
        }
        if(this.form[this.formItem.id] instanceof Array){
          let is = false
          this.form[this.formItem.id].forEach(item=>{
            if(childrenItem.parentValue.split(',').indexOf(item)>=0){
              is = true
            }
          })
          return is
        }else{
          return childrenItem.parentValue.split(',').indexOf(this.form[this.formItem.id])>=0
        }
      },

    }
  }
</script>

<style scoped lang="less">
  .divider{
    margin: 15px 0;
  }
  .form-model-item{
    margin-bottom: 0;
    padding: 0;

    /deep/ .ant-space-item{
      // width: 100%;
    }

    /deep/ .ant-input-number,
    /deep/ .ant-calendar-picker,
    /deep/ .ant-input {
      width: 100%;
      border-radius: 12px;
    }

    /deep/ .ant-input-number-handler-wrap{
      border-radius: 0 12px 12px 0;
    }
  }
  .row-block{
    display: block;
    line-height: 30px;
  }

  .btn{
    width: 155px;
    float: right;
    button{
      z-index: 99;
    }
  }
  .item-tip{
    float: left;
    button{
      z-index: 99;
    }
  }
  /deep/ .pad-font>div>label{
    font-size: 14px !important;
  }
  .record{    
    padding: 0px;    
    color:#59C62C;
  }
</style>